import { useQuery, useLazyQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { FAVORITE_LISTS } from "../../queries";
import InfoTable from "../Tables/InfoTable";
import animetionLogo from "../../assets/utils/images/animetion_logo.gif";

const Favorite = ({ userId, refetch }) => {
  const {
    loading,
    error,
    data,
    refetch: favoriteListRefetch,
  } = useQuery(FAVORITE_LISTS, {
    variables: { user: userId },
  });

  const [isFirst, setIsFirst] = useState(true);

  useEffect(() => {
    if (isFirst) {
      favoriteListRefetch();
      setIsFirst(!isFirst);
    }
  }, []);

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    window.location.href = "/#/dashboards/journy";
    window.location.reload();
  }
  if (!data) return "...Not Found";

  const favoriteOrg =
    data &&
    data.allFavorites &&
    data.allFavorites.edges &&
    data.allFavorites.edges.map((array) => array.node) &&
    data.allFavorites.edges.map((array) => array.node.org);

  return (
    <div>
      <InfoTable
        orgListData={favoriteOrg}
        title="お気に入りリスト"
        refetch={refetch}
      />
    </div>
  );
};

export default Favorite;
